import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { getSubdomain } from 'tldts';
import { ForgotDialogComponent } from '../forgot-dialog/forgot-dialog.component';
import { AccountService } from '../services/account.service';
import { AutoshipConfigurationService } from '../services/autoshipConfiguration.service';
import { Cart1Service } from '../services/cart1.service';
import { ConfigService } from '../services/config.service';
import { NotificationService } from '../services/notification.service';
import { OrderService } from '../services/order.service';
import { ProductService } from '../services/product.service';
import { RestApiService } from '../services/restapi.service';
import { UserService } from '../services/user.service';
import { UtilityService } from '../services/utility.service';


@Component({
  selector: 'app-login-dialog-component',
  templateUrl: './login-dialog-component.component.html',
  styleUrls: ['./login-dialog-component.component.scss']
})
export class LoginDialogComponentComponent implements OnInit {
  _forMobileScreen:any=false

  public userInfo = {
    username: '',
    password: '',
    guestemail: ''
  };
  userService: UserServiceModal;
  public guestUser = {};
  public issignin = true;
  public isguest = true;
  public showLoginSection: boolean = false;
  previousType: any;

  constructor(
    public dialogRef: MatDialogRef<LoginDialogComponentComponent>,
    private titleService: Title,
    private router: Router,
    private accountService: AccountService,
    public user: UserService,
    public orderService: OrderService,
    public cartsService: Cart1Service,
    public notificationService: NotificationService,
    public translate: TranslateService,
    public itemsService: ProductService,
    public apiService: RestApiService,
    private cookieService: CookieService,
    public utilityService: UtilityService,
    public autoshipConfigurationService: AutoshipConfigurationService,
    public configService: ConfigService,
    public dialog: MatDialog
  ) {

    this.userService = user.userServiceModal;
    this.cookieService.deleteAll('/');
  }

  ngOnInit() {
    this._forMobileScreen = window.innerWidth <= 700;

    this.translate.get('global_Company_Title').subscribe((text: string) => {
      this.titleService.setTitle(this.translate.instant('pagetitle_login') + ' | ' + text);
    });
    window.scrollTo(0, 0);
    this.previousType = this.userService.customerTypeID;
    this.load();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onClear(): void {
    this.dialogRef.close();
  }

  private load() {
    sessionStorage.setItem('PostLoginEvents', null);

    if (this.userService.customerData && !this.userService.customerData.FirstName) {
    }
  }

  checkitem() {
    return (this.itemsService.selectedOrderItems.length > 0 || this.itemsService.selectedAutoOrderItems.length > 0);
  }

  manageflow(guest, signin) {
    this.isguest = guest;
    if (signin) {
      this.clearStorage();
      const url = 'Home';
      window.open(url, '_self');
    } else {
      this.issignin = signin;
    }
  }

  private clearStorage() {
    this.orderService.calculateOrderResponse = {};
    this.cartsService.clearCart();
    this.user.clearData();
    this.user.setDefault();
    sessionStorage.removeItem('guestLogin');
  }

  loginFunction(username?: string, password?: string) {
    sessionStorage.setItem('guestLogin', 'false');
    this.user.clearCustomerData();
    sessionStorage.removeItem('guestLogin');
    const loginrequest = {
      granttype: 'password',
      scope: 'office',
      username: username || this.userInfo.username,
      password: password || this.userInfo.password
    };
    this.apiService.Login(loginrequest).subscribe(
      (result) => {
        if (result && result.status == 200 && result.body.Status != 1) {
          try {
            sessionStorage.setItem('isLoggedIn', 'true');

      this.apiService.GetCustomerRewardPoints(result.body.CustomerId)
      .subscribe((result: any) => {
        const { Data } = result;
        if(typeof Data == "number") {
          console.log("reward point Data",Data);
          this.userService.customerData['rewardPointBalance'] = Data;

        }
      });
            this.accountService.getCustomerData(result.body.CustomerId).then((data: any) => {
              if (data && data.Data) {
                sessionStorage.setItem('user', JSON.stringify(data.Data));
                this.userService.customerData = data.Data;
                sessionStorage.setItem('userService', JSON.stringify(this.userService));
                this.userService.customerTypeID = this.userService.customerData.CustomerType;
                // Ensure sessionStorage is set for iOS compatibility
                sessionStorage.setItem('selectedCustomerTypeID', this.userService.customerTypeID.toString());
                sessionStorage.setItem('userService', JSON.stringify(this.userService));
                if (this.previousType !== this.userService.customerTypeID) {
                  this.userService.couponInfo.Allcoupons = [];
                  this.autoshipConfigurationService.autoshipDate = '';
                  this.userService.shippingMethods = [];
                  this.userService.selectedShippingMethod = "";
                  this.autoshipConfigurationService.init();
                }
                if (!this.utilityService.isEmptyObject(this.userService.customerData.DefaultShippingAddress)) {
                  this.user.setShippingAddress();
                } else {
                  this.userService.shippingAddress = new UserServiceModal().newshippingAddress;
                }

                if (this.userService.customerData.WebAlias) {
                  this.apiService.validateWebAlias(this.userService.customerData.WebAlias).subscribe((res: any) => {
                    if (res.Data) {
                      this.userService.WebAlias = this.userService.customerData.WebAlias;
                      this.loginredirect(this.userService.WebAlias);
                    }else{
                      this.userService.WebAlias = this.userService.customerData.WebAlias;
                      // this.router.navigate(['/shop']);
                      location.href = `${location.origin}/${this.userService.WebAlias}/shop`;
                      this.dialogRef.close(true)
                    }
                  }, (error) => {
                    if (error.Data && !error.Data.WebAlias) {
                      this.notificationService.error('error_', 'webalias_not_exists');
                      return false;
                    }
                  },
                    () => {

                    });
                }
                else if (this.userService.customerData.SponsorId) {
                  this.apiService.getSearchCustomerDetail(this.userService.customerData.SponsorId).subscribe((resp: any) => {
                    if (resp.Data) {
                      this.apiService.validateWebAlias(resp.Data.WebAlias).subscribe((res: any) => {
                        if (res.Data) {
                          this.userService.WebAlias = resp.Data.WebAlias;
                          location.href = `${location.origin}/${resp.Data.WebAlias}`;
                        }
                      }, (error) => {
                        if (error.Data && !error.Data) {
                          this.notificationService.error('error_', 'webalias_not_exists');
                          return false;
                        }
                      },
                        () => {

                        });
                    }
                  }, (error) => {
                    if (error.Data && !error.Data.WebAlias) {
                      this.notificationService.error('error_', 'webalias_not_exists');
                      return false;
                    }
                  },
                    () => {

                    });
                }
              } else {
                this.notificationService.error('error_', 'error_occured_try_again');
              }
            }).catch((error) => {
              this.notificationService.error('error_', 'error_occured_try_again');
              console.error('ex', error);
            });
          } catch (successEx) {
            this.notificationService.error('error_', 'error_occured_try_again');
            console.error('ex', successEx);
          }
        } else {
          this.notificationService.error('error_', 'Authentication Failed');
        }
      }, err => {
        this.notificationService.error('error_', 'error_occured_try_again');
      },
      () => {

      });
  }



  // *********** new method from neumi ****************
  private loginredirect(alias) {
    let newUrl: any;
    const subdomain = getSubdomain(window.location.host);
    newUrl = `${location.origin}/${alias}`;

    if (this.checkitem()) {
      this.userService.checkItems = true;
      window.location.assign(newUrl.replace('login', 'checkout'));
    } else if (this.itemsService.selectedAutoOrderItems.length) {
      this.userService.checkItems = true;
      window.location.assign(newUrl.replace('login', 'products/all'));
    } else {
      window.location.assign(newUrl.replace('login', 'products/all'));
    }
  }

  navLoginPath(state) {
    this.router.navigate([state], { queryParams: { WebAlias: this.userService.WebAlias } });
  }


  redirectToForgotPassword() {
    this.onNoClick();
    const dialogRef = this.dialog.open(ForgotDialogComponent, {
      width: '800px',
      height: 'auto',
      data: LoginDialogComponentComponent,
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
    });



  }
  isMobile(): boolean {
    return false;
  }

  createGuestCustomer(guestemail) {
    this.userService.customerTypeID = 1;
    const randomPassword = '6Zy$Ce6yrzz';
    const request = {
      CustomerType: 1,
      EmailAddress: guestemail,
      FirstName: 'Guest User',
      LastName: 'Guest User',
      PrimaryAddress: {
        ShipTo: 'Guest User',
        Street1: 'No Address',
        Region: this.userService.regionMainState || 'UT',
        CountryCode: this.configService.commonData.selectedCountry || 'us'
      },
      SponsorId: this.userService.enrollerInfo.CustomerId || 2,
      Username: guestemail,
      Password: randomPassword
    };
    this.accountService.createGuestUser(request).subscribe((result) => {
      try {
        if (Number(result.Data) > 0) {
          this.loginFunction(this.userInfo.guestemail, randomPassword);
          this.userService.newUser = true;

          this.notificationService.success('Success', 'customer_created_successfully');
        } else {
          this.notificationService.error('error_', result.ErrorDescription);
        }
      } catch (ex) {
        this.notificationService.error('error_', 'error_occured_try_again');
      }
    },
      err => {
        // Do stuff whith your error
      },
      () => {

      });
  }

  showLogin(value: boolean) {
    this.showLoginSection = value;
  }
  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event) {
    this.windowResize(event);
  }
  windowResize(event: Event): void {
    this._forMobileScreen = window.innerWidth <= 700;
  }
}
